const THUMB_PALETTE = [
  "#0f62fe",
  "#6366f1",
  "#0ea5e9",
  "#14b8a6",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
  "#10b981",
  "#f97316",
] as const;

/** Stable per-SKU colour so each row gets a consistent, varied thumbnail. */
export function thumbColor(sku: string): string {
  let hash = 0;
  for (let i = 0; i < sku.length; i++) {
    hash = (hash * 31 + sku.charCodeAt(i)) >>> 0;
  }
  return THUMB_PALETTE[hash % THUMB_PALETTE.length]!;
}

/** First alphabetic character of the label, uppercased; falls back to "S". */
export function thumbInitial(label: string): string {
  return label.match(/[A-Za-z]/)?.[0]?.toUpperCase() ?? "S";
}

/** A subtle 140° gradient of the per-SKU colour, matching the playground thumbnails. */
export function thumbGradient(sku: string): string {
  const c = thumbColor(sku);
  return `linear-gradient(140deg, ${c}, ${c}cc)`;
}
